import * as React from 'react';

import { ITabs, TTabsType } from '../../../types/newbuildingTiledCarousel';
import { Tab } from './Tab';

export interface ITabsProps {
  activeTab: string | number;
  tabs: ITabs[];
  onChange(value: string | number, type: TTabsType): void;
}

export const TabsComponent: React.FC<ITabsProps> = ({ activeTab, tabs, onChange }) => {
  const [focusVisible, setFocusVisible] = React.useState(false);

  const onClick = ({ e, value, type }: { e: React.MouseEvent; value: string | number; type: TTabsType }) => {
    setFocusVisible(false);
    onChange(value, type);
  };

  return (
    <div>
      {tabs.map(({ value, title, type }) => (
        <Tab
          key={value}
          title={title}
          active={value === activeTab}
          focusVisible={focusVisible}
          onClick={(e: React.MouseEvent) => onClick({ e, value, type })}
        />
      ))}
    </div>
  );
};
